import { ComponentProps } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

const Container = styled(Box)`
	background: ${(props) => props.theme.colors.whiteBlue};
	border-radius: 10px;
`;

export default function Section(props: ComponentProps<typeof Container>) {
	return (
		<Container {...props} padding={[20, 20, 20, 40]}>
			{props.children}
		</Container>
	);
}
